import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import classNames from 'classnames';

const ProductListSkeleton: React.FC<any> = ({ viewRef, cmsComponentKey }) => {
  return (
    <div className="bg-surface-100-bg pt-1 pb-16 my-3" ref={viewRef} data-module={cmsComponentKey}>
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg h-5 w-24 rounded-sm skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden flex pt-0 mt-1" style={{ flexFlow: 'wrap' }}>
        <div className={classNames('w-1/2  box-border pl-2 pr-1.5 mb-2')}>
          <div className="bg-surface-200-bg rounded-600 skeleton" style={{ height: 304 }}></div>
        </div>

        {new Array(4).fill(0).map((_item, index) => {
          const isLeft = index / 2 === 0;
          return (
            <ProductCardSkeleton
              key={`skeleton-product-list-item-${index}`}
              className={classNames('w-1/2 box-border', { 'pl-2 pr-1': isLeft, 'pl-1 pr-2': !isLeft })}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProductListSkeleton;
